import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'unh-generic-row-container',
  styleUrls: ['./generic-row-container.component.scss'],
  template: `
    <div class="uh-generic-row">
      <ng-container [ngSwitch]="slot">
        <ng-container *ngSwitchCase="'avatar'">
          <div class="">
            <ng-content select="unh-user-avatar"></ng-content>
          </div>

          <ng-content></ng-content>
        </ng-container>

        <ng-container *ngSwitchCase="'actions'">
          <div class="">
            <ng-content select="unh-user-avatar"></ng-content>
          </div>

          <ng-content></ng-content>
        </ng-container>

        <ng-container *ngSwitchDefault>
          <ng-content></ng-content>
        </ng-container>
      </ng-container>
    </div>
  `
})
export class GenericRowContainerComponent implements OnInit {
  @Input() slot = 'default';


  constructor() { }

  ngOnInit() {
  }

}
